const CheckoutInitialState = {
  checkoutMode: "address",
};

export default CheckoutInitialState;
